import React, { useState } from "react";
import { MdOutlineClearAll } from "react-icons/md";
import MobileNav from "./MobileNav";
import NavbarUl from "./NavbarUl";

const Navbar = () => {
  const [mobileNav, setMobileNav] = useState(false);
  return (
    <div className="fixed top-0 left-0 right-0 font-serif bg-[#FCFCFC]  border-b-2 border-[#000000] lg:px-[90px] z-10 ">
      <div className=" flex justify-between items-center p-4">
        <div className="lg:hidden">
          <MdOutlineClearAll
            onClick={() => setMobileNav(!mobileNav)}
            size={30}
          />
        </div>
        <div className="hidden lg:flex text-[8px] h-[45px]">
          <h1 className="text-[40px] text-[#343D68] h-full font-bold  ">H</h1>
          <div className="lg:flex flex-col justify-center">
            <h1 className="text-[15px] text-[#000000] font-bold mt-3">
              aruna Idris
            </h1>
            <p className="">ERE FOR YOU !</p>
          </div>
        </div>
        <MobileNav mobileNav={mobileNav} setMobileNav={setMobileNav} />
        <NavbarUl />
      </div>
    </div>
  );
};

export default Navbar;
